export const ErrorMessage = {
  EVENT_ID_NOT_PROVIDED: "event-id-not-provided",
  NOT_FOUND: "not-found",
  INTERNAL_SERVER_ERROR: "internal-server-error"
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ErrorMessage = (typeof ErrorMessage)[keyof typeof ErrorMessage];
